import { ILanguageSwitched } from '../../../actions/userAccount/user/switchLanguage'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: ILanguageSwitched,
): IUserAccountStore {
  return {
    ...state,
    user: {
      ...state.user,
      savedLanguage: action.language,
    },
  }
}
